import React from 'react';

const UploadIcon: React.FC = () => (
  <svg>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      fill="none"
      stroke={'#1859B4'}
      strokeWidth="2"
      strokeDasharray="8 5"
    />
  </svg>
);

export default UploadIcon;